import { axiosInstance } from '../../utils';

export const getUserCredit = async (): Promise<any> => {
  const res = await axiosInstance.get('/api/videos/user-credits');
  return res.data;
};
